export default "__VITE_ASSET__WG8ICFHh__"